import { Component, ReactElement, ReactNode } from 'react';
import AppError from './AppRouter/AppError';
import {
  logUnknownError,
  setLogContext,
  setLogContextProperty
} from '../../utils/logger';

type Props = {
  children: ReactNode;
  fallback?: ReactElement;
};

type State = {
  error: boolean;
};

export default class ErrorBoundary extends Component<Props, State> {
  static defaultProps = {
    fallback: (
      <div className="App">
        <AppError
          title="Noe gikk galt"
          description="Det oppstod en feil. Du kan prøve på nytt eller komme tilbake senere."
          action={{
            label: 'Prøv på nytt',
            onAction: () => window.location.reload()
          }}
        />
      </div>
    )
  };

  constructor(props: Props) {
    super(props);
    this.state = { error: false };
  }

  static getDerivedStateFromError() {
    return { error: true };
  }

  componentDidCatch(error: Error, info: any) {
    setLogContext({ component: 'ErrorBoundary' });
    Object.keys(info).forEach(key => {
      setLogContextProperty(key, info[key]);
    });
    logUnknownError(error);

    // eslint-disable-next-line no-console
    console.error(error, info);
  }

  render() {
    if (this.state.error) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}
